export default __webpack_public_path__ + "448e55a61e3d9d2396b0838dfd49e453.svg";